module.exports = __webpack_public_path__ + "img/national.70a0f698.svg";